import React, { useMemo } from 'react';
import { IShopNavigationMenuItem, NAVIGATION_SLUGS } from '../model';
import Furniture from './Furniture/Furniture';
import Outdoor from './Outdoor/Outdoor';

interface ICategoryMenuDropdownListProps {
  navItem: IShopNavigationMenuItem;
}

const CategoryMenuDropdownList = ({
  navItem,
}: ICategoryMenuDropdownListProps) => {
  const menu = useMemo(() => {
    switch (navItem.slug) {
      case NAVIGATION_SLUGS.FURNITURE:
        return <Furniture navItem={navItem} />;
      case NAVIGATION_SLUGS.OUTDOOR:
        return <Outdoor navItem={navItem} />;
      default:
        return null;
    }
  }, [navItem.slug]);

  return (
    <>
      {menu}
    </>
  );
};

export default CategoryMenuDropdownList;
